<template>
  <div class="step">
    {{ this.title }}
  </div>
</template>

<script>
export default {
  name: "StepSon",
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>

<style lang="stylus" scoped>
.step
  width 90px
  height 30px
  line-height 30px
  text-align center
  background #f4f7fa
  margin-left 15px
  position relative
  text-indent 15px
  font-size 14px
  color #666
  font-weight: 700;
  &:first-child
    position relative
    &::after
      content ""
      display inline-block
      position absolute
      right -15px
      width 15px
      height 30px
      background #f4f7fa
      border-radius 0 15px 15px 0
    &.active
      background #2d8cf0
      color #fff
      &::after
        background #2d8cf0

  &:not(:first-child):not(:last-child)
    &::before
      content ""
      display inline-block
      position absolute
      left 0
      width 15px
      height 30px
      background #fff
      border-radius 0 15px 15px 0
    &::after
      content ""
      display inline-block
      position absolute
      right -15px
      width 15px
      height 30px
      background #f4f7fa
      border-radius 0 15px 15px 0
    &.active
      background #2d8cf0
      color #fff
      &::after
        background #2d8cf0

  &:last-child
    &::before
      content ""
      display inline-block
      position absolute
      left 0
      width 15px
      height 30px
      background #fff
      border-radius 0 15px 15px 0
    &.active
      background #2d8cf0
      color #fff
</style>
